
import { Quill, QuillOptionsStatic } from "quill";
import Vue from "vue";
import { AWSFileService } from "../../services/aws-file-service";


export default Vue.extend({
	data() {
		return {
			quillKey: Math.random(),
			quill: null as Quill | null,
			focused: false,
		};
	},
	props: {
		isHtml: {
			type: Boolean,
			required: true
		},
		value: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean
		}
	},
	computed: {
		quillOptions():QuillOptionsStatic {
			return {

			};
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				if (this.$refs.textarea) {
					(this.$refs.textarea as HTMLTextAreaElement).value = this.value;
				}
			}
		}
	},
	methods: {
		onHtmlEditorFocus(quill: Quill) {
			this.focused = true;
			this.quill = quill;
		},
		async handlerImageAdded(file: File, Editor: any, cursorLocation: number, resetUploader: any) {
			console.log("Image added");
			let awsFile = await AWSFileService.uploadFile("/email-templates", file);
			let url = awsFile.getUrl();
			Editor.insertEmbed(cursorLocation, "image", url);
			resetUploader();
		},
		updateCursorPosition() {
			if (!this.focused) return;
			if (!this.isHtml) {
				let el = this.$refs.textarea as HTMLTextAreaElement;
				this.$emit("cursor-position-change", el.selectionStart);
			} else if (this.quill) {
				let selection = this.quill.getSelection(true);
				if (selection) {
					this.$emit("cursor-position-change", selection.index);
				}
			}
		},
		onTextContentChange(value:string) {
			this.$emit("input", value);
			this.$emit("text-value", value);
		},
		emitHtmlContent(){
			if (!this.quill) return;
			console.log("HTML EDITED");
			this.$emit("text-value", this.quill.getText());
			this.updateCursorPosition();
		},
		async reloadQuill(){
			this.quill = null;
			this.quillKey = Math.random();
		},
		onHtmlContentChange(value:string) {
			if (!this.focused) return;
			let removeBinaryImagesRegex = /<img \s*src="data:image\/[^\"]*"\s*\/?>/g;
			if (removeBinaryImagesRegex.test(value)){
				console.log("Has image");
				value = value.replaceAll(value, "");
				this.reloadQuill();
				return;
			}
			console.log("Content changed");
			this.$emit("input", value);
			this.emitHtmlContent();
		},
		insertImage(url:string){
			if (!this.isHtml) {
				return;
			}
			if (!this.quill) return;
			let range = this.quill.getSelection(true);
			if (!range) return;
			let start = range.index;
			this.quill.insertEmbed(start, "image", url);
			this.$emit("text-value", this.quill.getText());
		},
		insertText(toAddText:string) {
			console.log("On insert", toAddText);
			if (!this.isHtml) {
				let textarea = this.$refs.textarea as HTMLTextAreaElement;
				let start = textarea.selectionStart;
				let text = this.value;
				text = text.slice(0, start) + toAddText + text.slice(start, text.length);
				this.$emit("input", text);
				this.$emit("text-value", text);
			} else {
				if (!this.quill) return;
				let range = this.quill.getSelection(true);
				if (!range) return;
				let start = range.index;
				this.quill.insertText(start, toAddText);
				this.$emit("text-value", this.quill.getText());
			}
		},
		insertLink(text:string, url:string) {
			console.log("On insert link");
			if (!this.isHtml) {
				this.insertText(url);
				return;
			}
			if (!this.quill) return;
			let range = this.quill.getSelection(true);
			if (!range) return;
			let start = range.index;
			this.quill.updateContents({
				ops: [
					{
						retain: start
					},{
						insert: text,
						attributes: {
							link: url
						}
					}
				]
			} as any);
			this.$emit("text-value", this.quill.getText());
		}
	},
	components: {
		VueEditor: () => import("@/utils/vue-editor")
	},
	i18nEx: {
		componentPrefix: "components.mail"
	}
});
